import spinnerAnimation from '../../../Assets/Images/Spinner/Spinner.webp';
import { useTranslation } from '../../../i18n/useTranslation';
import './Spinner.css';

/**
 * A busy indicator that announces itself. `role="status"` means a screen
 * reader says "loading" instead of nothing happening at all, and the label is
 * visually hidden rather than absent.
 *
 * The animated mark — the Magbit checkmark spinning — is the spinner
 * wherever there is room for it. Its source render sat on an opaque black
 * background; the asset here has that key removed (alpha per pixel, not a
 * hard cutout, so the shadowed side of the mark during rotation keeps its
 * shading instead of punching a hole), so it floats on the page directly.
 * Two things replace it with a plain CSS ring: `inline` (inside a button,
 * where the mark is needlessly heavy for a 16px throbber), and
 * `prefers-reduced-motion` (a frame animation cannot be paused on its own).
 * Spinner.css shows exactly one of the two elements for any combination.
 */
export function Spinner({ inline = false }: { inline?: boolean }) {
  const { tr } = useTranslation();
  return (
    <div className={inline ? 'spinner is-inline' : 'spinner'} role="status">
      <img src={spinnerAnimation} alt="" className="spinner-gif" />
      <span className="spinner-ring" aria-hidden="true" />
      <span className="visually-hidden">{tr('loading')}</span>
    </div>
  );
}
